import React from "react";
import { Icon, Image, Link } from "components";
import { WpPost, WpProject_Gallery } from "codegen";
import "./post-card.scss";

interface PostCardProps {
  item: WpPost | WpProject_Gallery;
}

/**
 * Card to display post information
 *
 * @param item Data for individual card
 * @returns Card format for post item
 *
 */
export const PostCard = ({ item }: PostCardProps): JSX.Element => {
  return (
    <Link className="post-card" to={item.uri}>
      <div className="post-card__image">
        {item.featuredImage && <Image src={item.featuredImage?.node} alt={item.title && ""} />}
        <Icon name="ArrowLink" size="4" color="--brand-secondary" />
      </div>
      <div className="post-card__content">
        <h3>{item.title}</h3>
        {item.postInformation?.postDescription && (
          <p
            dangerouslySetInnerHTML={{
              __html: item.postInformation?.postDescription,
            }}
          />
        )}
      </div>
    </Link>
  );
};
